import React, { Component } from "react";
import moment from "moment";
import { Modal, DatePicker } from "antd";
import "./index.less";

const nowDate = moment().format("YYYYMMDD");
const nowDateMoment = moment();

class DatePickerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nowState: "now",
      nowReadDate: nowDate
    };
  }

  componentDidMount() {
    const { nowActivity } = this.props;
    const { status, endDate } = nowActivity;
    const activityEndTime = moment(endDate).format("YYYYMMDD");
    if (status === 2 && nowDate > activityEndTime) {
      this.setState({
        nowState: "over"
      });
    }
  }

  // 点击modal框的确定按钮
  handleOk = () => {
    const { nowReadDate, nowState } = this.state;
    const { onOk } = this.props;
    if (onOk) {
      onOk(nowReadDate, nowState);
    }
  };

  // 日期更改时的回调
  handleDayChange = date => {
    const changedDate = moment(date).format("YYYYMMDD");
    const { nowActivity } = this.props;
    const { startDate, endDate, status } = nowActivity;
    const activityTime = moment(startDate).format("YYYYMMDD");
    const activityEndTime = moment(endDate).format("YYYYMMDD");
    if (status === 2 && changedDate > activityEndTime) {
      this.setState({
        nowState: "over"
      });
    } else if (changedDate > nowDate && status === 1) {
      this.setState({
        nowState: "after"
      });
    } else if (changedDate < activityTime) {
      this.setState({
        nowState: "ago"
      });
    } else if (
      changedDate > activityTime ||
      changedDate < nowDate ||
      changedDate === nowDate
    ) {
      this.setState({
        nowState: "now"
      });
    }
    this.setState({
      nowReadDate: date ? changedDate : ""
    });
  };

  render() {
    const { visible, onCancel } = this.props;
    const { nowReadDate } = this.state;
    const modalProps = {
      visible,
      title: "打卡明细",
      wrapClassName: "activitySign-datePicker-modal",
      onCancel,
      onOk: this.handleOk,
      okButtonProps: {
        disabled: !nowReadDate
      }
    };
    const datePickerProps = {
      onChange: this.handleDayChange,
      defaultValue: nowDateMoment
    };
    return (
      <Modal {...modalProps}>
        日期：
        <DatePicker {...datePickerProps} />
      </Modal>
    );
  }
}

export default DatePickerModal;
